import { useQuery } from '@apollo/react-hooks';
import { GET_ACADEMIC_ASSESSMENTS } from './ACADEMIC_ASSESSMENTS.gql';
import type { GetAcademicQualificationAssessment } from './types';
import type { AcademicAssessment } from '../../../../DRCAssessment';
import type { FilterType } from '../types';

export const useGetAcademicQualificationAssessment = (
  filter: FilterType,
): GetAcademicQualificationAssessment => {
  const { data, loading, error, refetch } = useQuery(GET_ACADEMIC_ASSESSMENTS, {
    variables: { filter },
    fetchPolicy: 'network-only',
  });
  const academicQualificationAssessment: AcademicAssessment[] =
    data?.academicQualificationAssessment ?? [];

  return { academicQualificationAssessment, loading, error, refetch };
};
